<div [formGroup]="selectControl">
  <ng-select
    [items]="options$ | async"
    placeholder="Please select"
    [searchable]="searchable"
    [clearable]="false"
    class="custom-multiselect"
    bindLabel="title"
    bindValue="id"
    [labelForId]="labelForId"
    [formControlName]="formControlName"
    typeToSearchText="{{
      'autocomplete_type_to_search' | translate : { minNum: minTermLength }
    }}"
    [addTag]="addTagFn"
    addTagText="Create new"
  >
  </ng-select>
</div>